var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["switch_box", { active: _vm.value }],
      on: { click: _vm.switchChange }
    },
    [
      _c("div", { class: ["switch_child", { child_active: _vm.value }] }, [
        _vm._v("\n    " + _vm._s(_vm.value ? "开" : "关") + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9260807a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9260807a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/switch-button/index.vue
// module id = Kw+l
// module chunks = 0 7 12 13 14 17 26 28 30 32 34 52 65 134